export default [
    {
        path: '/',
        name: 'home',
        component() {
            return import('./views/Home');
        },
        meta: {
            title: 'EmpowerDirect.com',
        },
    },
    {
        path: '/liz-mann/',
        name: 'lizmann',
        component() {
            return import('./views/LizMann');
        },
        meta: {
            title: 'Liz Mann',
        },
    },
    {
        path: '/roman-meytin/',
        name: 'romanmeytin',
        component() {
            return import('./views/RomanMeytin');
        },
        meta: {
            title: 'Roman Meytin',
        },
    },
    {
        path: '/404',
        component() {
            return import('./views/PageNotFound');
        },
        meta: { sitemap: { ignoreRoute: true } },
    },
    {
        path: '*',
        redirect: '/404',
    },
];
